import React, { useEffect, useState } from 'react'
import 'date-fns'
import Grid from '@material-ui/core/Grid'
import theme from '../theme'
import useAsync from '../hooks/useAsync'
import { useClaimant } from '../context/col'
import { useStyles } from './styled'

import InsuranceForm from '../components/forms/InsuranceForm'
import { TripForm } from '../components/forms/TripForm'
import {
  CaseReportParamsType,
  CaseReportRespType,
  InsuranceDataType,
  transformCaseReportRespToCaseReportParams,
  TravelContextType,
} from '../models'
import { putCaseReport } from '../services/case-report/put'
import useGetData from '../hooks/useGetData'

export type TripPageProps = {
  transitions: TripPageTransitions
}

export type TripPageTransitions = {
  goBack: () => void
  goToChangeInsurance: () => void // to edit basic case report values
  goToClaimantPage: () => void // claimant page == second page
}

const TripPage = (props: TripPageProps) => {
  const classes = useStyles(theme)
  const { state, dispatch } = useClaimant()
  const [ifEqual, setIfEqual] = useState<boolean>(true)

  const { fetch: fetchData } = useGetData({})

  React.useEffect(() => {
    fetchData()
  }, [])

  const { fetch: doPutCaseReport, pending: tripPending } = useAsync({
    promiseFn: (params: any) => putCaseReport(params),
    onData: () => {
      dispatch({ type: 'control_change', payload: { controlChange: true } })
      /*dispatch({
        type: 'update_page',
        payload: { page: 1 },
      })*/
      //history.push(pathToClaimant)
      props.transitions.goToClaimantPage()
    },
    onError: (error) => {
      dispatch({ type: 'error', payload: { error: error.message } })
    },
  })

  const handleTripPageSubmitted = (tripDataParams: TravelContextType) => {
    const {
      loadedCaseReportResp,
    }: { loadedCaseReportResp: CaseReportRespType | undefined } = state

    delete tripDataParams.attachmentList
    const newCaseReportDataResp = {
      ...loadedCaseReportResp,
      trip: tripDataParams,
    } as CaseReportRespType

    // 2. Pripravena finalni data, ktera se budou odesilat
    const caseReportParamsForUpdate: CaseReportParamsType =
      transformCaseReportRespToCaseReportParams(newCaseReportDataResp)

    // 3. aktualizujeme state -- do currentCaseReportData nastavime newCaseReportDataResp
    //    a zmenime 'stranku'
    dispatch({
      type: 'update_caseReportParams',
      payload: { data: newCaseReportDataResp, page: 1 },
    })

    doPutCaseReport({
      caseReportId: state.caseReportId,
      caseReportParams: caseReportParamsForUpdate,
    })
  }

  const changeSubmit = () => {
    props.transitions.goToChangeInsurance()
  }

  const handleTripPageBack = () => {
    props.transitions.goBack()
  }

  useEffect(() => {
    dispatch({ type: 'control_change', payload: { controlChange: ifEqual } })
  }, [dispatch, ifEqual])

  const insuranceData: InsuranceDataType | undefined =
    state.loadedCaseReportResp?.insurance ?? undefined

  const tripData = {
    ...state.loadedCaseReportResp?.trip,
    attachmentList: state.loadedCaseReportResp?.attachmentList,
  }

  return (
    <Grid className={classes.root}>
      <Grid
        item
        sm={12}
        xl={12}
        xs={12}
        container
        direction="row"
        className={classes.gridMainFormInsurance}
      >
        <InsuranceForm
          viewMode={true}
          insuranceFormData={insuranceData}
          onChangeInsuranceRequested={changeSubmit}
          caseType={state.caseType}
        />
        <TripForm
          caseReportId={state.caseReportId!}
          tripFormData={tripData}
          onPageContinue={handleTripPageSubmitted}
          onPageBack={handleTripPageBack}
          errorMessage={state.error}
          isContinueInProgress={tripPending}
          onDataChanged={setIfEqual}
          caseType={state.caseType}
        />
      </Grid>
    </Grid>
  )
}

export default TripPage
